import { useQuery } from '@tanstack/react-query';
import { subscriptionApi } from '~/lib/request';
import { TransactionResponse } from './types';

function usePendingTransactions() {
  const result = useQuery({
    queryKey: ['pendingTransactions'],
    queryFn: () =>
      subscriptionApi
        .get('api/transactions/transactions', {
          searchParams: new URLSearchParams([
            ['status', 'new'],
            ['limit', '3'],
          ]),
        })
        .json<TransactionResponse>(),
    throwOnError: true,
  });

  return { data: result?.data, isLoading: result.isLoading };
}

export default usePendingTransactions;
